export const paymentConstants = {
  getFinanceRequest: "GET_FINANCE_REQUEST",
  getFinanceSuccess: "GET_FINANCE_SUCCESS",
  getFinanceFailure: "GET_FINANCE_FAILURE",

  createPaymentRequest: "CREATE_PAYMENT_REQUEST",
  createPaymentSuccess: "CREATE_PAYMENT_SUCCESS",
  createPaymentFailure: "CREATE_PAYMENT_FAILURE",

  updatePaymentRequest: "UPDATE_PAYMENT_REQUEST",
  updatePaymentSuccess: "UPDATE_PAYMENT_SUCCESS",
  updatePaymentFailure: "UPDATE_PAYMENT_FAILURE",

  deletePaymentRequest: "DELETE_PAYMENT_REQUEST",
  deletePaymentSuccess: "DELETE_PAYMENT_SUCCESS",
  deletePaymentFailure: "DELETE_PAYMENT_FAILURE",

  createAlertRequest: "CREATE_ALERT_REQUEST",
  createAlertSuccess: "CREATE_ALERT_SUCCESS",
  createAlertFailure: "CREATE_ALERT_FAILURE",

  updateAlertRequest: "UPDATE_ALERT_REQUEST",
  updateAlertSuccess: "UPDATE_ALERT_SUCCESS",
  updateAlertFailure: "UPDATE_ALERT_FAILURE",

  deleteAlertRequest: "DELETE_ALERT_REQUEST",
  deleteAlertSuccess: "DELETE_ALERT_SUCCESS",
  deleteAlertFailure: "DELETE_ALERT_FAILURE",

  clearPaymentState: "CLEAR_PAYMENT_STATE",
};
